/**
 * TanStack Query hooks for `igaming-self-excluded-player-filter-never-credit-a`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys,
	type CreateIgamingSelfExcludedPlayerFilterNeverCreditABody,
	type ListIgamingSelfExcludedPlayerFilterNeverCreditAResponse,
	type IgamingSelfExcludedPlayerFilterNeverCreditARow,
} from "./api";

export function useIgamingSelfExcludedPlayerFilterNeverCreditAList(): UseQueryResult<ListIgamingSelfExcludedPlayerFilterNeverCreditAResponse, Error> {
	return useQuery({
		queryKey: igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingSelfExcludedPlayerFilterNeverCreditACreate(): UseMutationResult<IgamingSelfExcludedPlayerFilterNeverCreditARow, Error, CreateIgamingSelfExcludedPlayerFilterNeverCreditABody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys.all });
		},
	});
}

export function useIgamingSelfExcludedPlayerFilterNeverCreditADelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys.all });
		},
	});
}
